module.exports = new __parcel__URL__("dark.cacd877b.svg").toString();